var map = {
	"./arrow-right.svg": 98283,
	"./arrow-uturn-up-cross.svg": 30962,
	"./bell-notification-alarm.svg": 58532,
	"./box-delivery-package-car-pin-location-group.svg": 16227,
	"./button-arrow-left-circle.svg": 10744,
	"./button-arrow-right-circle.svg": 21339,
	"./calculator.svg": 59983,
	"./calendar-31.svg": 87518,
	"./calendar-add-circle.svg": 44708,
	"./checkmark-done-check.svg": 41612,
	"./checkmark-square-empty.svg": 25126,
	"./checkmark-square.svg": 33330,
	"./chevron-down.svg": 31865,
	"./chevron-left.svg": 56482,
	"./chevron-right.svg": 37817,
	"./chevron-up.svg": 97430,
	"./cloud-upload.svg": 38200,
	"./column-artboard.svg": 98899,
	"./contract-document-seal.svg": 90241,
	"./credit-card-security-protection.svg": 62762,
	"./cross-head-circle.svg": 16705,
	"./cursor-swipe-down.svg": 10317,
	"./cursor-swipe-left.svg": 13334,
	"./cursor-swipe-right.svg": 27317,
	"./cursor-swipe-up.svg": 99410,
	"./dashboard-6.svg": 71924,
	"./delete-disabled-cross.svg": 15944,
	"./delete-disabled.svg": 68711,
	"./delivery-shipment-packages-setting.svg": 51439,
	"./document-cross-delete-left.svg": 24689,
	"./document-edit.svg": 34637,
	"./document-file-cross-deelte.svg": 4350,
	"./document-file-cross-delete-circle.svg": 52537,
	"./document-file-download.svg": 90016,
	"./document-file-eye.svg": 40479,
	"./documents-file-add-plus.svg": 84705,
	"./documents-file-arrow.svg": 65750,
	"./documents-file-delete-cross.svg": 93957,
	"./documents-file-search.svg": 10439,
	"./done-check-checkmark.svg": 78712,
	"./download-square.svg": 71121,
	"./earth-home-world.svg": 16376,
	"./email-mail-checkmark.svg": 23227,
	"./eye-cross.svg": 74625,
	"./eye-open.svg": 69579,
	"./file-blank-add-plus.svg": 38159,
	"./list-basket-checkmark.svg": 99602,
	"./lock-3.svg": 44862,
	"./lock-shield-prote.svg": 39099,
	"./lock-unlock.svg": 28207,
	"./menu-burger-arrow-circle.svg": 54969,
	"./menu-edit-pen-add-circle.svg": 39588,
	"./package-box-arrow-up.svg": 51541,
	"./package-box-arrow.svg": 2081,
	"./package-box-warning.svg": 71118,
	"./pen-edit.svg": 18705,
	"./search-1.svg": 45101,
	"./setting-edit-filter-gear-square-1.svg": 62551,
	"./settings-circle-2.svg": 5228,
	"./shield-protection-square.svg": 33619,
	"./shopping-cart.svg": 46834,
	"./single-user-add-plus.svg": 77280,
	"./single-user.svg": 30117,
	"./slides-windows.svg": 86657,
	"./support-headphones.svg": 62156,
	"./trash-delete-bin-2.svg": 84540,
	"./user-profile-square.svg": 43750,
	"./warehouse-delivery.svg": 89145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62550;